import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef, NbDialogService, NbMenuItem } from "@nebular/theme";

@Component({
  selector: "ngx-dialog-notifications",
  templateUrl: "dialog-notifications.component.html",
  styleUrls: ["dialog-notifications.component.scss"],
})
export class DialogNotificationsComponent implements OnInit {
  constructor(protected ref: NbDialogRef<DialogNotificationsComponent>) {}

  ngOnInit() {}

  close() {
    this.ref.close();
  }
}
